import { useCallback, useEffect, useState } from "react";
import FilterOrders from "./FilterOrders";
import Loading from './../Loading';
import axios from "axios";
import { Get_orders } from "../../api/api";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import Table from "rc-table";
import { separate } from "../PaymentHistory";
import InfiniteScroll from "react-infinite-scroller";
import useAuth from "../../hooks/useAuth";
import { checkRole } from "../../services/help";
import ItemPopupTable from "./ItemPopupTable";
import { IoMdCloseCircle } from "react-icons/io";

const columns1 = [
    {
        title: 'شماره سفارش',
        dataIndex: 'id',
        key: 'id',
        width: 100
    },
    {
        title: 'خریدار',
        dataIndex: 'buyer',
        key: 'buyer',
        width: 100
    },
    {
        title: 'محصول',
        dataIndex: 'product',
        key: 'product',
        width: 100
    },
    {
        title: 'مبلغ',
        dataIndex: 'price',
        key: 'price',
        width: 100
    },
    {
        title: 'همکار فروش',
        dataIndex: 'colleague',
        key: 'colleague',
        width: 100
    },
    {
        title: 'درگاه پرداخت',
        dataIndex: 'gateway',
        key: 'gateway',
        width: 100
    },
    {
        title: 'تاریخ خرید',
        dataIndex: 'date',
        key: 'date',
        width: 100
    },
    {
        title: 'وضعیت پرداخت',
        dataIndex: 'status',
        key: 'status',
        width: 101
    }

]
const columns2 = [
    {
        title: 'شماره سفارش',
        dataIndex: 'id',
        key: 'id',
        width: 100
    },
    {
        title: 'محصول',
        dataIndex: 'product',
        key: 'product',
        width: 100
    },
    {
        title: 'همکار فروش',
        dataIndex: 'colleague',
        key: 'colleague',
        width: 100
    },
    {
        title: 'تاریخ خرید',
        dataIndex: 'date',
        key: 'date',
        width: 100
    },
    {
        title: 'وضعیت پرداخت',
        dataIndex: 'status',
        key: 'status',
        width: 101
    }

]
const columns3 = [
    {
        title: 'شماره سفارش',
        dataIndex: 'id',
        key: 'id',
        width: 100
    },
    {
        title: 'محصول',
        dataIndex: 'product',
        key: 'product',
        width: 100
    },
    {
        title: 'مبلغ',
        dataIndex: 'price',
        key: 'price',
        width: 100
    },
    {
        title: 'درگاه پرداخت',
        dataIndex: 'gateway',
        key: 'gateway',
        width: 100
    },
    {
        title: 'تاریخ خرید',
        dataIndex: 'date',
        key: 'date',
        width: 100
    },
    {
        title: 'وضعیت پرداخت',
        dataIndex: 'status',
        key: 'status',
        width: 101
    }

]
const columns4 = [
    {
        title: 'شماره سفارش',
        dataIndex: 'id',
        key: 'id',
        width: 100
    },
    {
        title: 'محصول',
        dataIndex: 'product',
        key: 'product',
        width: 100
    },
    {
        title: 'تاریخ خرید',
        dataIndex: 'date',
        key: 'date',
        width: 100
    },
    {
        title: 'وضعیت پرداخت',
        dataIndex: 'status',
        key: 'status',
        width: 101
    }

]

const Orders = () => {

    const { auth } = useAuth()
    const isAdmin = checkRole(auth, ['ADMIN'])

    const [columns, setColumns] = useState(columns1)

    const [showDetails, setShowDetails] = useState(true)
    const [isLoading, setLoading] = useState(false)
    const [notFound, setNotFound] = useState(false)
    const [item, setItem] = useState([])
    const [isError, setIsError] = useState(false)
    const [fetching, setFetching] = useState(false)
    const [pageNum, setPageNum] = useState(1)

    const location = useLocation()
    const params = useParams()
    const [searchParams] = useSearchParams();


    useEffect(() => {
        setItem([])
        setNotFound(false)
        setPageNum(1)
        setLoading(true)
        setExpandedRowKeys([])
    }, [params, searchParams])


    useEffect(() => {
        if (!showDetails) {
            if (!isAdmin) {
                setColumns(columns4)
            } else {
                setColumns(columns2)
            }
        } else {
            if (!isAdmin) {
                setColumns(columns3)
            } else {
                setColumns(columns1)
            }
        }
    }, [showDetails])


    //loadmore
    const fetchItems = useCallback(
        async () => {
            if (fetching || isError) {
                return;
            }

            setFetching(true);

            try {
                setLoading(true)
                const res = await axios.get(Get_orders(pageNum, 20, location.search))
                res.data != '' ? setPageNum(pageNum + 1) : setPageNum(null)
                res.data == '' && pageNum === 1 ? setNotFound(true) : setNotFound(false)

                if (res.data) {
                    for (let index = 0; index < res.data?.length; index++) {
                        const element = res.data[index]
                        setItem(s => {
                            return [
                                ...s,
                                {
                                    key: index + element.buyer + element.paymentId,
                                    id: element.paymentId,
                                    subjectId: element.subjectId,
                                    buyer: element.buyer,
                                    product: <button className="moreDetailsProduct" onClick={() => handleOpenRowTable(index + element.buyer + element.paymentId, element.subjectId)}>{element.subjectBranchTitle}</button>,
                                    price: separate(element.price),
                                    colleague: element.publisher,
                                    gateway: element.gateWay,
                                    date: element.regDate,
                                    status: <><div className={element.state === 'پرداخت شده' ? 'statetext completed' : 'statetext failed'}>{element.state}</div></>,
                                }
                            ];
                        });
                    }
                }

            } catch (err) {
                setIsError(true)
            } finally {
                setFetching(false)
                setLoading(false)
            }

        },


        [item, fetching, pageNum]
    );

    const hasMoreItems = !!pageNum;
    //loadmore


    const [subjectIDPopup, setSubjectIDPopup] = useState(0)
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    const handleOpenRowTable = (subjectIDPopup, subjectID) => {
        setExpandedRowKeys([subjectIDPopup])
        setSubjectIDPopup(subjectID);
    }
    const closeAll = () => setExpandedRowKeys([]);


    return (
        <div className="orders">
            <FilterOrders isAdmin={isAdmin} showDetails={setShowDetails} />
            <div style={{ padding: '1rem' }}>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='box_radios'>
                            <div className='chartHolder'>
                                <InfiniteScroll
                                    loadMore={fetchItems}
                                    hasMore={hasMoreItems}
                                    loader={<Loading key={pageNum} styles={'mini'} />}
                                >
                                    <Table columns={columns} data={item} tableLayout='auto'
                                        emptyText=""
                                        expandable={{
                                            columnTitle: <span>title</span>,
                                            expandRowByClick: true,
                                            expandedRowRender: (record, index, indent, expanded) => (<>
                                                <button type="button" className="closePopupTable" onClick={closeAll}><IoMdCloseCircle /></button>
                                                <ItemPopupTable key={index + subjectIDPopup} subjectId={subjectIDPopup} />
                                            </>),
                                            expandedRowKeys,
                                        }}
                                    />
                                </InfiniteScroll>
                            </div>
                            {notFound ? (<p style={{ textAlign: 'center' }}>هیچ داده ای برای نمایش وجود ندارد!</p>) : ''}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Orders;